import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Status, UpdateStatus } from './status.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class StatusService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status.list;

    public listDTUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status.listDT;

    private findURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status.find;

    private storeURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status.store;

    private updateUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status.update;

    private deleteUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status
            .public;

    private changeStatusArhivaUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.status.archive;

    private updateOrderUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.status.updateOrder;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: Status) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: UpdateStatus) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getStatusesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.listActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        // archive: item.archive,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get statuses active:', error);
                    return throwError(error);
                })
            );
    }

    getStatusesPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    updateOrder(id: number, data: any) {
        return this.http.put(this.updateOrderUrl + id, data, this.httpOptions);
    }

    changeStatusArhiva(id: number) {
        return this.http.put(this.changeStatusArhivaUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
